import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import _get from 'lodash/get';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { TSegmentFormData } from '../../utils/types';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const data: TSegmentFormData = hydrateFormData(_get(location, ['state', 'rowData']));
	const { uploadCsvEdit } = useService();

	const editSegment = async (updatedData: any) => {
		try {
			const { csvData } = updatedData;
			const formData = new FormData();
			setShowLoader(true);

			_forEach(_keys(csvData), (key: string) => {
				formData.append(key, csvData[key]);
			});
			uploadCsvEdit(formData).then(
				(res: any) => {
					if (res?.status !== 200 || !res?.data?.success) {
						showAlert(res?.data?.error || 'Error occured while editing segment', { type: 'error' });
						setShowLoader(false);
						history.goBack();
					} else {
						showAlert('New Segment CSV uploaded');
						setShowLoader(false);
						history.goBack();
					}
				},
				(err: any) => {
					showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
					setShowLoader(false);
				}
			);
		} catch (error: any) {
			showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: TSegmentFormData) => {
		editSegment(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
